import { Link, useSearchParams } from "react-router-dom";
import { useSEO } from "../lib/useSEO";
import { SectionLabel } from "../components/SectionLabel";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const back = params.get("back") || "/vault";
  useSEO("Checkout Cancelled", "No charge was made.");

  return (
    <div data-testid="payment-cancel-page" className="pt-40 pb-32 min-h-screen">
      <div className="max-w-xl mx-auto px-5 sm:px-8 text-center">
        <SectionLabel center>The Royal Vault</SectionLabel>
        <h1 className="font-serif text-4xl sm:text-5xl tracking-tight text-cream">NO CHARGE WAS MADE.</h1>
        <p className="mt-5 text-sand leading-relaxed">
          You stepped away before completing checkout. The Vault isn't going anywhere — the music will be here when you're ready.
        </p>
        <Link
          to={back}
          data-testid="cancel-back-to-vault-btn"
          className="mt-9 inline-flex h-13 px-9 py-4 items-center bg-gold text-obsidian font-mono text-[11px] tracking-[0.3em] uppercase hover:bg-goldglow transition-colors"
        >
          Back to the Vault
        </Link>
      </div>
    </div>
  );
}
